var $1f0dc3b9307be026$exports = {};
const $1f0dc3b9307be026$var$openBtn = document.getElementById('open-menu');
const $1f0dc3b9307be026$var$closeBtn = document.getElementById('close-menu');
const $1f0dc3b9307be026$var$mobileMenu = document.getElementById('mobile-menu');
// Open menu
$1f0dc3b9307be026$var$openBtn.addEventListener('click', ()=>{
    $1f0dc3b9307be026$var$mobileMenu.classList.remove('hidden');
    $1f0dc3b9307be026$var$openBtn.classList.add('hidden');
    $1f0dc3b9307be026$var$closeBtn.classList.remove('hidden');
});
// Close menu
$1f0dc3b9307be026$var$closeBtn.addEventListener('click', ()=>{
    $1f0dc3b9307be026$var$mobileMenu.classList.add('hidden');
    $1f0dc3b9307be026$var$closeBtn.classList.add('hidden');
    $1f0dc3b9307be026$var$openBtn.classList.remove('hidden');
});


//# sourceMappingURL=theme.js.map
